export const FIXED_HEADER_THRESHOLD = 60;

export const getRatingsCount = (count: number): string => {
  if (count < 1000) return `${count}`;
  if (count === 1000) return '1k';
  return '1k+';
};
